module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f98a.42aba0ba.svg";